import { cueQuotaStatistics } from '@/views/home/api'

const quotaStatistics = {
  state: {
    statisticsData: null,
  },
  mutations: {
    SET_STATISTICS(state, statisticsData) {
      state.statisticsData = statisticsData
    },
  },
  actions: {
    async theCueQuotaStatistics({ commit, state }) {
      try {
        const { code, data } = await cueQuotaStatistics()
        if (code === 200) {
          commit('SET_STATISTICS', data)
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}

export default quotaStatistics